<!-- BaseTab.vue (admin) -->
<template tag="관리자 탭 컴포넌트">
  <v-tabs
    v-model="selectedTab"
    :class="className"
    :bg-color="bgColor"
    :color="color"
    :style="{ '--tab-font-size': tabFontSize }"
  >
    <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value">
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedTab = defineModel<string>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  tabs: { type: Array<{ label: string; value: string }>, default: () => [] },
  bgColor: { type: String, default: "" },
  className: { type: String, default: "" },
  color: { type: String, default: "primary" },
  size: {
    type: String as PropType<"sm" | "md" | "lg">,
    default: "md",
    validator: (v: string) => ["sm", "md", "lg"].includes(v),
  },
});

/* ------------------------------------------------------------
                          Variables
   ------------------------------------------------------------ */
const fontSizeMap = {
  sm: "12px",
  md: "14px",
  lg: "16px",
} as const;

const tabFontSize = computed(() => fontSizeMap[props.size as keyof typeof fontSizeMap]);
</script>
